import React from "react";
import { Routes, Route } from "react-router-dom";

import Setting from "./pages/Setting";
import Performance from "./pages/Performance";
import News from "./pages/News";
import Inquiry from "./pages/Inquiry";
import Login from "./pages/Login";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import EmailCollectionRefusal from "./pages/EmailCollectionRefusal";
import NewsDetail from "./pages/NewsDetail";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import InquiryDetail from "./pages/InquiryDetail";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/service-settings" element={<Setting />} />
      <Route path="/service-performance" element={<Performance />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route
        path="/email-collection-refusal"
        element={<EmailCollectionRefusal />}
      />
      <Route path="/news" element={<News />} />
      <Route path="/news-detail" element={<NewsDetail />} />
      <Route path="/inquiry" element={<Inquiry />} />
      <Route path="/inquiry-detail" element={<InquiryDetail />} />
      <Route path="/products" element={<Products />} />
      <Route path="/products-detail" element={<ProductDetail />} />
    </Routes>
  );
}
